module.exports = __webpack_public_path__ + "10eea59bec75dfcedf9d08cc680a5119.svg";